import { cn } from '@/lib/utils'

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
} as const

export type SpinnerSize = keyof typeof sizeClasses

interface SpinnerIconProps {
  readonly size?: SpinnerSize
  readonly className?: string
}

/** Apenas o icone giratorio, decorativo (aria-hidden). Uso interno de outros componentes (ex.: Button). */
export function SpinnerIcon({ size = 'md', className }: SpinnerIconProps) {
  return (
    <svg
      className={cn('animate-spin text-current', sizeClasses[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4Z"
      />
    </svg>
  )
}

export interface SpinnerProps extends SpinnerIconProps {
  /** Texto anunciado por leitores de tela: obrigatorio pois o Spinner e usado sem texto visivel ao redor. */
  readonly label: string
}

/** Indicador de carregamento acessivel para uso isolado (ex.: tela cheia, secao assincrona). */
export function Spinner({ label, ...iconProps }: SpinnerProps) {
  return (
    <span role="status" className="inline-flex items-center gap-2">
      <SpinnerIcon {...iconProps} />
      <span className="sr-only">{label}</span>
    </span>
  )
}
